import { useForm } from "@kanda-libs/ks-component-ts";
import { StringIndexedObject } from "@kanda-libs/ks-design-library";
import { useSelector } from "react-redux";
import { selectors } from "store";

export interface CreateJobFromLeadModalFormValues {
  cid: string;
}

export interface CreateJobFromLeadModalFormHook {
  form: ReturnType<typeof useForm<CreateJobFromLeadModalFormValues>>;
  isSubmitting: boolean;
  onSubmit: (formValues: StringIndexedObject) => void;
  hasQuote: boolean;
  onChangeCid: (cid?: string) => void;
}

export default function useCreateJobFromLeadModalForm(
  onCreateJobFromLead: (cid: string) => void
): CreateJobFromLeadModalFormHook {
  const form = useForm<CreateJobFromLeadModalFormValues>();
  const lead = useSelector(selectors.lead.getEntity);
  const isSubmitting = useSelector(selectors.lead.getIsSubmitting);

  const hasQuote = !!lead?.lead_quote;

  const onSubmit = (formValues: StringIndexedObject) => {
    const values = formValues as CreateJobFromLeadModalFormValues;
    const { cid } = values;

    onCreateJobFromLead(cid);
  };

  const onChangeCid = (cid?: string) => {
    form.setValue("cid", cid || "");
  };

  return {
    form,
    isSubmitting,
    onSubmit,
    hasQuote,
    onChangeCid,
  };
}
